import { useCallback } from 'react';
import type { GoodsOption } from 'shared/src/api';
import { bridge, getWebBaseURL } from 'shared/src/utils';
import { useProductCheckout } from '../queries/useProductCheckout';
import { useLogClickCheckOut } from './useLogClickCheckOut';
import { useMyInfo } from 'shared/src/queries';

export const useOnPressPurchase = ({
  selected,
  onCompletePurchase,
  onAnonymouseUserPressedPurchase,
}: {
  selected: GoodsOption[];
  onCompletePurchase: () => void;
  onAnonymouseUserPressedPurchase: () => void;
}) => {
  const { mutateAsync: checkoutProduct, isPending: loadingProductCheckout } =
    useProductCheckout(selected);
  const { data: myInfo } = useMyInfo();
  const logClickCheckOut = useLogClickCheckOut({ selected });

  const onPressPurchase = useCallback(async () => {
    if (myInfo?.is_anonymous) {
      onAnonymouseUserPressedPurchase();
      return;
    }
    logClickCheckOut();
    const result = await checkoutProduct();

    if (result) {
      bridge.openDeeplink(result.deeplink, {
        webCallback: async () => {
          const baseURL = await getWebBaseURL();
          location.href = `${baseURL}/payment/checkout/${result.checkout_key}`;
        },
      });
      onCompletePurchase();
    }
  }, [
    checkoutProduct,
    logClickCheckOut,
    myInfo?.is_anonymous,
    onAnonymouseUserPressedPurchase,
    onCompletePurchase,
  ]);

  return { onPressPurchase, loadingProductCheckout };
};